import React, { CSSProperties } from 'react';
import { ContentListItem } from '../../../_lib/components/ContentList';
import { ContentListItemModifier } from '../../../_lib/components/ContentList/parials/ContentListItem';

export type CategoriesListItemProps = {
  children: React.ReactNode;
  style?: CSSProperties;
};

/**
 * CategoriesListItem with modifiert to be mapped to each category.
 */
export function CategoriesListItem({ children, style }: CategoriesListItemProps) {
  return (
    <ContentListItem
      modifier={[ContentListItemModifier.BORDER_LEFT, ContentListItemModifier.PADDING_15_TOP_BOTTOM]}
      style={style}
    >
      {children}
    </ContentListItem>
  );
}
